const useIsMobile = () => document.documentElement.clientWidth < 897;
export default useIsMobile;
